import axiosInstance from "../axiosInstance";
import { distinctValuesService } from "./distinct-values.service";

/**
 * Transfer orders synced from Pipe17 into control-tower (api/transfer-order),
 * and the backfill trigger (api/transfer-order-sync). Status is Pipe17's own value.
 */
export const transferOrderService = {
  // Newest first. `client` is only needed for admins; a client user's token
  // already limits the list to their own transfers.
  fetch: async (client, query, { signal } = {}) => {
    let apiQuery = `/transfer-order?$sort[provider_created_at]=-1&$populate[0][path]=client_id&$populate[0][select]=${encodeURIComponent("name business_name")}`;
    if (client) apiQuery += `&client_id=${client}`;
    if (query && query.length) apiQuery += `&${query}`;
    const response = await axiosInstance.get(apiQuery, { signal });
    return response.data;
  },

  fetchById: async (id) => {
    const response = await axiosInstance.get(
      `/transfer-order/${id}?$populate[0][path]=line_items.product&$populate[0][select]=name&$populate[1][path]=from_warehouse&$populate[1][select]=name&$populate[2][path]=to_warehouse&$populate[2][select]=name`,
    );
    return response.data;
  },

  // Starts the client's Pipe17 transfer backfill (via the provider path).
  // Asynchronous: returns { started, client_id } before any transfer lands.
  sync: async (clientId, { since } = {}) => {
    const response = await axiosInstance.post(`/transfer-order-sync`, {
      ...(clientId && { client_id: clientId }),
      ...(since && { since }),
    });
    return response.data;
  },

  fetchDistinct: async (field, searchKey = "", client_id, limit = 15, skip = 0) =>
    distinctValuesService.fetchColumnValues("transfer-order", field, searchKey, client_id, limit, skip),
};
